<template lang="pug">
  div(style="width:100%; height:100%; min-height:height;")
    v-chart-bar(v-if="isLineOrBar" :data="innerData" :labels="labels" :columns="columns" :options="innerOptions", :colors="colors")
    v-chart-pie(v-else-if="isPie" :data="innerData" :labels="labels" :options="innerOptions")
    v-chart-scatter(v-else-if="isScatter" :data="innerData" :labels="labels" :columns="columns" :options="innerOptions")

</template>

<script>
import $ from "jquery";
import ChartHelpers from "../mixins/charts/helpers";
import Bar from "./charts/bar";
import Pie from "./charts/pie";
import Scatter from "./charts/scatter";

const MAX_TITLE_LENGHT = 95;

export default {
  name: "b-chart",
  props: ["data", "show_title", "filters", "showby", "type", "options"],
  data() {
    return {
      backgroundColor: "transparent",
      showTitle: this.options.show_title == 1 ? true : false
      //showTitle: true
    };
  },
  computed: {
    height() {
      return `${
        this.options && this.options.height
          ? this.options.height
          : $(window).height() < 650
          ? $(window).height() < 300
            ? 300
            : $(window).height()
          : 650
      }px`;
    },
    currentType() {
      return this.$props.type ? this.$props.type : this.$props.options.default;
    },
    isLineOrBar() {
      return this.$root.isLineOrBar(this.currentType);
    },
    isPie() {
      return this.$root.isPie(this.currentType);
    },
    isScatter() {
      return ["scatter-simple"].includes(this.currentType);
    },
    isStackedBar() {
      return ["bar-100", "bar-stacked"].includes(this.currentType);
    },
    masterField() {
      return this.$props.options.fields.filter(row => row.is_master_field)[0];
    },
    innerData() {
      let labelField = this.$props.options.fields.filter(
        row => row.value == this.$props.showby
      )[0];
      if (!labelField) return [];

      let result = [];
      let filters = this.innerOptions.filters;
      const valueFields = this.$props.options.fields.filter(
        row => row.is_value
      );

      this.$props.data
        .filter(row => {
          let fields = Object.keys(row);
          for (let key in filters) {
            let value = filters[key];
            if (
              (key == this.$props.showby && !this.innerOptions.ignoreShowBy) ||
              fields.indexOf(value) > -1
            )
              continue;
            else if (row[key] != value) return false;
          }
          return true;
        })
        .forEach(row => {
          if (this.isScatter) {
            const desc = this.$props.options.fields.filter(row => {
              return !row.is_value && this.$props.showby !== row.value;
            })[0];

            desc.data.forEach(description => {
              if (row[desc.value] !== description) return;

              result.push({
                label: row[labelField.value],
                description: description,
                value: valueFields.map(column => {
                  return this.parseValue(row[column.value], this.isStackedBar);
                })
              });
            });
          } else {
            valueFields.forEach(column => {
              if (this.isStackedBar) {
                result.push({
                  label:
                    this.masterField &&
                    this.$props.showby === this.masterField.value
                      ? this.masterField.name
                      : row[labelField.value],
                  description: this.masterField
                    ? row[this.masterField.value]
                    : column.name,
                  value: this.parseValue(row[column.value], this.isStackedBar),
                  is_grupable: column.is_grupable
                });
              } else {
                result.push({
                  label: row[labelField.value],
                  description:
                    this.masterField &&
                    this.$props.showby !== this.masterField.value
                      ? row[this.masterField.value]
                      : column.name,
                  value: this.parseValue(row[column.value], this.isStackedBar),
                  is_grupable: column.is_grupable
                });
              }
            });
          }
        });

      return result;
    },
    colors() {
      const default_colors = this.$props.options.colors || [
        "#FFD45E",
        "#EC6E41",
        "#346899",
        "#37B7C1",
        "#000000",
        "#2B455E",
        "#3BBBE2",
        "#C9E4F4",
        "#EE4655",
        "#A6A6A6"
      ];

      const indices = this.columns.map(column => {
        const result = this.masterField
          ? this.$props.data
              .map(row => row[this.masterField.value])
              .filter((item, i, arr) => arr.indexOf(item) == i)
              .sort()
          : this.$props.options.fields
              .filter(row => row.is_value)
              .map(row => row.name);
        return result.indexOf(column);
      });

      const result = default_colors.filter((_, i) => indices.includes(i));
			console.log(result)

      return result.length > 0 ? result : default_colors;
    },
    columns() {
      if (this.masterField) {
        return this.innerData
          .map(row => row.description)
          .filter((item, i, arr) => arr.indexOf(item) == i)
          .sort();
      } else {
        return this.$props.options.fields
          .filter(row => row.is_value)
          .map(row => row.name);
      }
    },
    areMasterFieldLabels() {
      return (
        this.isStackedBar &&
        this.masterField &&
        this.$props.showby === this.masterField.value
      );
    },
    labels() {
      if (this.areMasterFieldLabels) return [this.masterField.name];

      const result = this.$props.options.fields
        .filter(row => row.value == this.$props.showby)
        .map(row => row.data)
        .flat();

      return Object.freeze(result);
    },
    innerOptions() {
      let filters = {};

      for (let key in this.$props.filters) {
        let value = this.$props.filters[key];
        if (value != null && value != undefined) filters[key] = value;
      }

      let options = {
        ignoreShowBy: this.$props.filters
          ? Object.keys(this.$props.filters).length === 1 && this.isPie
          : false,
        filters: filters,
        backgroundColor: this.backgroundColor,
        showTitle: this.showTitle,
        type: this.$props.type,
        showBy: this.$props.showby,
        height: this.height,
        colors: []
      };

      for (let key of Object.keys(this.$props.options || {})) {
        options[key] = this.$props.options[key];
      }

      if (options.title && options.title.length > MAX_TITLE_LENGHT) {
        options.title = wordWrap(options.title, MAX_TITLE_LENGHT);
      }

      return options;
    }
  },
  methods: {
    download() {
      this.backgroundColor = "#fff";
      this.showTitle = true;
      setTimeout(() => {
        let filename = (this.innerOptions.title || "Indicadores OEC").replace(
          /[\W_]+/g,
          " "
        );
        let canvas = $("#chart canvas")[0];
        let a = document.createElement("a");
        a.download = filename.length > 255 ? filename.substr(0, 255) : filename;
        a.href = canvas.toDataURL("image/png");
        a.click();
        this.backgroundColor = "transparent";
        this.showTitle = false;
      }, 50);
    }
  },
  mixins: [ChartHelpers],
  components: {
    "v-chart-bar": Bar,
    "v-chart-pie": Pie,
    "v-chart-scatter": Scatter
  }
};

function wordWrap(str, maxWidth) {
  var newLineStr = "\n";
  var done = false;
  var res = "";
  do {
    var found = false;
    // Inserts new line at first whitespace of the line
    for (var i = maxWidth - 1; i >= 0; i--) {
      if (testWhite(str.charAt(i))) {
        res = res + [str.slice(0, i), newLineStr].join("");
        str = str.slice(i + 1);
        found = true;
        break;
      }
    }
    // Inserts new line at maxWidth position, the word is too long to wrap
    if (!found) {
      res += [str.slice(0, maxWidth), newLineStr].join("");
      str = str.slice(maxWidth);
    }

    if (str.length < maxWidth) done = true;
  } while (!done);

  return res + str;
}

function testWhite(x) {
  var white = new RegExp(/^\s$/);
  return white.test(x.charAt(0));
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// chart.vue